import Vue from 'vue'
import moment from 'moment'

require('moment/locale/es')
moment.locale('es')

const pipe = {
  NUMBER: function (event) {
    let keyCode = event.keyCode
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault()
    }
  },
  DOUBLE: function (event) {
    event = event || window.event
    let isPoint = event.srcElement.value.includes('.')
    let isResta = event.srcElement.value.includes('-')
    var charCode = event.which ? event.which : event.keyCode
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      charCode !== 46 &&
      charCode !== 45
    ) {
      event.preventDefault()
    } else {
      if (isPoint && event.key === '.') {
        event.preventDefault()
      }
      if (isResta && event.key === '-') {
        event.preventDefault()
      }
      if (event.srcElement.value !== '' && event.key === '-') {
        event.preventDefault()
      } else {
        return true
      }
    }
  },
  DATE: function (value) {
    return moment(String(value)).format('YYYY/MM/DD')
  },
  DATETIME: function (value) {
    return moment(String(value)).format('YYYY/MM/DD hh:mm:ss')
  },
  SIZE: function (value) {
    var _size = value
    var fSExt = ['Bytes', 'KB', 'MB', 'GB']
    var i = 0
    while (_size > 900) {
      _size /= 1024
      i++
    }
    var exactSize = Math.round(_size * 100) / 100 + ' ' + fSExt[i]
    return exactSize
  }
}

Vue.prototype.NUMBER = pipe.NUMBER
Vue.prototype.DOUBLE = pipe.DOUBLE
Vue.prototype.moment = moment

Vue.filter('DATE', pipe.DATE)
Vue.filter('DATETIME', pipe.DATETIME)
Vue.filter('SIZE', pipe.SIZE)

const MyPlugin = {
  install (Vue, options) {
    Vue.prototype.ViewOption = path => {
      const permissions = []
      return (
        permissions.findIndex(e => {
          return (
            e.route === path ||
            (!Array.isArray(e.items)
              ? -1
              : e.items.findIndex(i => {
                return i.route === path
              }) !== -1)
          )
        }) !== -1
      )
    }
  }
}

Vue.use(MyPlugin)

export default pipe



// WEBPACK FOOTER //
// ./src/pipe/index.js